import {StyleSheet} from 'react-native';
const getStyles = (colors: any) =>
  StyleSheet.create({
    container: {
      paddingRight: 16,
      marginTop: 10,
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    hiddenLabel: {
      opacity: 0,
    },
    inputStyle: {
      fontSize: 15,
      lineHeight: 18,
      paddingLeft: 15,
      width: '90%',
      paddingTop: 11,
      paddingBottom: 11,
      color: colors.black,
    },
  });

export default getStyles;
